import type { StripeElementsOptions } from '@stripe/stripe-js';

type ElementsWithPaymentMethodOptions = Extract<
  StripeElementsOptions,
  { paymentMethodCreation?: 'manual' }
>;

const instantWithMicrodepositFallback = 'automatic' as const;

export const usBankAccountPaymentMethodOptions = {
  us_bank_account: {
    verification_method: instantWithMicrodepositFallback,
    financial_connections: {
      permissions: ['payment_method'],
    },
  },
} satisfies NonNullable<ElementsWithPaymentMethodOptions['paymentMethodOptions']>;
